// หมวดเอกสารในเมนู Finance
//
// key ต้องตรงกับ FINANCE_CATEGORIES ฝั่ง server (server/config/constants.ts)
// ลำดับในลิสต์นี้คือลำดับที่แสดงในหน้า — "อื่น ๆ" อยู่ท้ายสุดเสมอ
import type { FinanceCategory } from "@features/documents/api/documents-api";

export const FINANCE_CATEGORIES: { key: FinanceCategory; label: string }[] = [
  { key: "master_plan", label: "Master Plan" },
  { key: "media_plan", label: "Media Plan" },
  { key: "tv_plan", label: "TV Plan" },
  { key: "other", label: "เอกสารอื่น ๆ" },
];

const BY_KEY = new Map(FINANCE_CATEGORIES.map((c) => [c.key, c.label]));

/** ไฟล์เก่าที่ไม่มีหมวด (หรือหมวดที่ถูกถอดออกภายหลัง) ให้ถือเป็น "อื่น ๆ" */
export const categoryLabel = (key: string | null): string =>
  BY_KEY.get((key ?? "other") as FinanceCategory) ?? "เอกสารอื่น ๆ";

export const DEFAULT_CATEGORY: FinanceCategory = "other";
